// extracted by mini-css-extract-plugin
export default {"privatPolicy":"AboutUs_privatPolicy__36q9U","subTitle":"AboutUs_subTitle__IOryi","text":"AboutUs_text__pprym"};